module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('back-button'), _vm._v(" "), _c('div', {
    staticClass: "code-name",
    staticStyle: {
      "padding-top": "90px"
    }
  }, [_vm._v("\n    Dynamic Items\n  ")]), _vm._v(" "), _c('swipe', {
    ref: "mySwipe",
    class: {
      'hide': !_vm.state
    },
    staticStyle: {
      "max-width": "500px",
      "margin": "0 auto"
    }
  }, _vm._l((_vm.items), function(it) {
    return _c('swipe-item', {
      key: it
    }, [_c('b', [_vm._v(_vm._s(it))])])
  })), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding-top": "20px"
    }
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.minus()
      }
    }
  }, [_vm._v(" - ")]), _vm._v(" "), _c('span', [_vm._v("SwipeItem Count: " + _vm._s(_vm.items.length))]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.plus()
      }
    }
  }, [_vm._v(" + ")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-56a8fad5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./demo/components/Dynamic.vue
// module id = 30
// module chunks = 0